import { BaseOverlayComponent } from '../base-overlay/base-overlay.component';

export class GenericOverlayComponent extends BaseOverlayComponent {
  /*
  * Override to specify code split template to use
  * */
  async getAsyncTemplate(){
    const templateFn: (...args: any[]) => string =
      await import('./generic-overlay.template.html') as any;
    this.templateFn = (templateFn as any).default;
  }
}
